{

    "meta": {
        "home": {
            "title": "Widerruf & Retoure | baum-bmwshop24.de",
            "description": "Hier können Sie Ihren Widerruf oder Ihre Retoure ganz einfach online einreichen. Bitte geben Sie Ihre Auftragsnummer und E-Mail-Adresse ein, um zu beginnen."
        }
    },
    "global": {
        
        "support": "Support",
        "content_loading": "Inhalt wird geladen...",
        "order_loading": "Bestellung wird geladen...",
        "order_cancelation_in_progress": "Bestellung wird storniert...",
        "searching": "Wird gesucht...",
        "oneMoment": "Einen Moment bitte...",
        "form_is_submitting": "Daten werden gesendet...",
        "please_wait_while_we_process": "Bei großen Datenmengen kann die Verarbeitung einige Zeit in Anspruch nehmen. Bitte haben Sie einen Moment Geduld, während wir Ihre Anfrage bearbeiten.",
        "error": "Ein Fehler ist aufgetreten.",
        "from": "von",
        "startFrom": "ab",
        "to": "bis",
        "notice": "Hinweis",
        "optional": "Optional",
        "optionalSquared": " (optional)",
        "privacy_policy": "Datenschutzbestimmungen",
        "amount": "Menge",
        "starts": "ab ",
        "sku": "Teilenummer",
        "welcome_to": "Willkommen bei baum-bmwshop24.de",
        "choose_option": "Treffen Sie eine Auswahl",
    },

    "countrySwitcher": {
        "title": "Sprache ändern",
        "description": "Bitte wählen Sie Ihre Sprache aus.",
    },

    "buttons": {
        "yes": "Ja",
        "yes_change": "Ja, ändern",
        "no": "Nein",
        "understood": "Verstanden",
        "close": "Schließen",
        "choose": "Auswählen",
        "change": "Ändern",
        "change_country": "Land ändern",
        "contactform": "Kontaktformular",
        "next": "Weiter",
        "back": "Zurück",
        "reset": "Zurücksetzen",
        "apply": "Anwenden",
        "find": "Finden",
        "save": "Speichern",
        "remove": "Entfernen",
        "submit": "Absenden",
        "refresh": "Aktualisieren",
        "cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "cancelOrder": "Bestellung stornieren",
        "to_homepage": "zur Startseite",
        "to_website": "zur Website",
        "back_to_shop": "Zurück zum Shop",
        "to_article": "Zum Artikel",
        "contact_support": "Support kontaktieren",
        "findOrder": "Bestellung finden",
        "return_portal": "Zum Retourenportal",
        "submit_rma": "Reklamation abschließen",
    },

    "form": {
        "pickup_file": "Datei hochladen",

        "_": "{{$0}}",
        "email": "E-Mail",
        "password": "Passwort",
        "password_repeat": "Passwort wiederholen",
        "firstname": "Vorname",
        "lastname": "Nachname",
        "name": "Name",
        "required_bold": " **(Pflicht)**",
        "phone": "Telefon",
        "message": "Nachricht",
        "streetAndNumber": "Straße & Hausnummer",
        "street": "Straße",
        "street_number": "Nr.",
        "appartment": "Adresszusatz (z.B. Wohnung, Etage)",
        "zipcode": "PLZ",
        "city": "Stadt",
        "country" : "Land",
        "company": "Unternehmen",
        "vin": "Fahrgestellnummer",
        "sku": "Teilenummer",
        "order_id": "Bestell- oder Auftragsnummer",
        "order_id_or_shop_order_id": "Auftragsnummer oder Shop Bestellnummer",
        "order_id_description": "Die Auftragsnummer, beginnend mit dem aktuellen Jahresdatum (zB. **2026**76...), finden Sie in Ihrer Auftragsbestätigung oder auf Ihrer Rechnung. **Es handelt sich nicht um die Shop Bestellnummer (#BB24xxxx)**",
        "qty": "Menge",
        "common_data": "Weitere Angaben",
        "common_data_for_spareparts": "Ergänzende Angaben",
        "current_km": "Aktueller Kilometerstand",
        "km_of_installation": "Kilometerstand bei Einbau",
        "workshop_invoice": "Werkstattrechnung anhängen",
        "vin_document": "Fahrzeugschein anhängen (Vorder- & Rückseite)",
        
        "privacy": {
            "label": "Datenschutzbestimmungen akzeptieren",
            "description": "Ich habe die Datenschutzbestimmungen gelesen und akzeptiere diese."
        },
        "errors": {
            "name": "Bitte geben Sie Ihren Namen ein.",
            "firstname": "Bitte geben Sie Ihren Vornamen ein.",
            "company": "Bitte geben Sie Ihren Firmennamen ein.",
            "lastname": "Bitte geben Sie Ihren Nachnamen ein.",
            "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            "message": "Bitte geben Sie eine Nachricht ein.",
            "phone": "Bitte geben Sie eine gültige Telefonnummer ein.",
            "order_id": "Bitte geben Sie eine gültige Auftragsnummer ein. Diese befindet sich in Ihrer Auftragsbestätigung oder auf Ihrer Rechnung und beginnt mit dem aktuellen Jahresdatum (zB. 2026). Es handelt sich **nicht** um die Shop Bestellnummer (#BB24xxxx).",
            "vin": "Bitte geben Sie eine gültige Fahrgestellnummer ein.",
            "sku": "Bitte geben Sie eine gültige 11-stellige Teilenummer ein.",
            "zipcode": "Bitte geben Sie eine gültige Postleitzahl ein.",
            "streetAndNumber": "Bitte geben Sie Straße und Hausnummer ein.",
            "termsAccepted": "Bitte akzeptieren Sie die AGB, Widerrufsbeleehrung und Datenschutzbestimmungen.",
            "city": "Bitte geben Sie eine Stadt ein.",
            "country": "Bitte wählen Sie ein Land aus.",
            "consent": "Bitte geben Sie Ihre Einwilligung zur Datenverarbeitung.",
            "subject": "Bitte geben Sie ein Thema an.",
            "vat_id" : "Bitte geben Sie eine gültige USt-IdNr. mit Ländercode (DEXXXXXXXXXX) ein.",
            "vat_id_invalid": "Die angegebene USt-IdNr. ist ungültig.",
            "vat_id_invalid_country": "Die angegebene USt-IdNr. stimmt nicht mit dem ausgewählten Land überein.",
            "privacy": "Bitte akzeptieren Sie die Datenschutzbestimmungen.",
            "captcha": "Bitte bestätigen Sie, dass Sie kein Roboter sind.",
            "captcha_mismatch": "Die Captcha-Bestätigung ist nicht korrekt.",
            "password_length": "Das Passwort muss mindestens 8 Zeichen lang sein.",
            "password_strength": "Das Passwort muss mindestens 8 Zeichen lang sein und Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen enthalten.",
            "password_confirmation": "Bitte bestätigen Sie Ihr Passwort.",
            "password_confirmation_mismatch": "Die Passwörter stimmen nicht überein.",
            "password_invalid": "Das Passwort entspricht nicht den Mindestanforderungen.",
            "max_file_size": "Die Datei überschreitet die maximale Größe von 5MB.",
            "image_upload_failed": "Der Upload der Bilder ist fehlgeschlagen. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support für weitere Hilfe.",
        }
    },

    "messages": {
        "error": {
            "title": "Ein Fehler ist aufgetreten.",
            "description": "Bitte versuchen Sie es später erneut.",
            "longtitle": "Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.",
        },
        "review": {
            "title": "Eingabe überprüfen",
            "description": "Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
        },
        "order_not_found": {
            "title": "Keine Bestellung gefunden.",
            "description": "Unter Angabe der Auftragsnummer und E-Mail-Adresse konnte keine Bestellung gefunden werden. Sollten Sie vor kurzem erst die Bestellung ausgelöst haben, **warten Sie bitte bis zu 15 Minuten,** bis unser System die Bestellung verarbeitet hat. Sollte es weiterhin nicht funktionieren, kontaktieren Sie unseren Support für weitere Hilfe.",
        },
        "not_stopable": {
            "title": "Bestellung bereits im Versandprozess",
            "description": "Leider können wir den Versand Ihrer Bestellung nicht mehr stoppen, da sie bereits unser Versandzentrum erreicht oder verlassen hat. Sie können die Bestellung jedoch über unser Retourenportal zurücksenden. Beim Versand mit DHL können Sie innerhalb Deutschlands, über den Sendunglink auch ein Paketstopp einleiten.",
        },
        "return_period_expired": {
            "title": "Widerrufsfrist abgelaufen",
            "description": "Leider ist die Widerrufsfrist für Ihre Bestellung bereits abgelaufen. Diese beträgt 14 Tage ab Erhalt der Ware. Für weitere Rückfragen oder Unterstützung können Sie gerne unseren Support kontaktieren.",
        },
        "image_upload_permission_denied": {
            "title": "Zugriff verweigert",
            "description": "Die Berechtigung zum Zugriff auf die Medienbibliothek ist erforderlich, um Bilder hochzuladen.",
        },
        "rma_period_expired": {
            "title": "Garantiezeit abgelaufen",
            "description": "Leider ist die Garantiezeit für die von Ihnen ausgewählten Artikel bereits abgelaufen. Bitte überprüfen Sie das Kaufdatum und die Garantiebedingungen für Ihre Artikel. Für weitere Fragen oder Unterstützung können Sie gerne unseren Support kontaktieren.",
        }
    },

    "language": {
        "de" : {
            "iso": "DE",
            "name": "Deutsch"
        }
    },

    "support": {
        "title": "Support",
        "description": "Kontaktieren Sie uns, wenn Sie Hilfe benötigen.",
        "productHelp": "Fragen",
        "instructions": {
            "title": "Anleitungen & Dokumente",
            "description": "Hier finden Sie hilfreiche Anleitungen rund um BMW & MINI.",
            "items": {
                "bmw_wheel_insurance": {
                    "title": "BMW Reifenversicherung",
                    "description": "Erfahren Sie mehr über die BMW Reifenversicherung und wie Sie Ihre Reifen optimal schützen können."
                },
                "which_bmw_navi": {
                    "title": "Welches BMW Navi ist das Richtige?",
                    "description": "Finden Sie heraus, welches BMW Navigationssystem am besten zu Ihren Bedürfnissen und Ihrem BMW passt."
                },
                "how_to_download_bmw_navi": {
                    "title": "Wie lade ich BMW Navigation Update herunter?",
                    "description": "Erfahren Sie Schritt für Schritt, wie Sie die neuesten Updates für Ihr BMW Navigationssystem herunterladen."
                },
                "how_to_install_bmw_navi": {
                    "title": "Wie installiere ich BMW Navigation Update?",
                    "description": "Erfahren Sie, wie Sie die Updates auf Ihrem BMW Navigationssystem installieren können."
                }
            }
        }, 
        "mail": {
            "title": "info@baum-bmwshop24.de",
            "description": "Schreiben Sie uns eine E-Mail und wir werden uns so schnell wie möglich bei Ihnen melden.",
        },
        "contactform": {
            "title": "Kontaktformular",
            "description": "Schreiben Sie uns ganz einfach eine E-Mail über unser Kontaktformular.",
        },
        
        "phone": {
            "title": "0 2641 - 30 81 020¹",
            "description": "Gerne können Sie uns auch telefonisch erreichen. Unsere Geschäftszeiten: Mo.-Do.: 9.00 - 17.00 Uhr , Fr.: 9.00 - 16.00 Uhr",
        },
        "retoure": {
            "title": "Retouren",
            "description": "Hier können Sie Retouren und Rücksendungen anmelden.",
        },
        "appointment": {
            "title": "Werkstatttermin",
            "description": "Vereinbaren Sie noch heute einen Werkstattbesuch in unserer Filiale in Bad Neuenahr-Ahrweiler.",
        },
        "faq": {
            "title": "FAQ",
            "description": "In unseren FAQ finden Sie Antworten auf häufig gestellte Fragen rund um BMW, MINI und unseren Shop.",
        },
        "lexikon": {
            "title": "BMW Lexikon",
            "description": "In unserem BMW Lexikon finden Sie Fachwissen rund um das vielfältige BMW und MINI Universum.",
        },
        "blog": {
            "title": "Blog",
            "description": "In unserem Blog erwarten Sie Neuigkeiten aus der BMW und MINI Welt und Wissenswertes rund um automobile Fahrkultur.",
        }
        
    },


    "footer": {
        "legalLinks": {
            "imprint": "Impressum",
            "privacy": "Datenschutz",
            "revocation": "Widerrufsbelehrung",
            "batteryRecycling": "Batteriegesetz",
            "terms": "AGB",
            "accessibility": "Barrierefreiheitsklärung"
        }
    },

    "revocation": {
        "steps": {
            "start": "Start",
            "notice": "Hinweis",
            "find_order": "Bestellung finden",
            "product_list": "Artikel auswählen",
            "cancel_order": "Bestellung stornieren",
            "success": "Erfolgreich eingereicht",
            "submit_rma": "Reklamation abschließen",
            "success_page": "Abschluss",
        }
    },

    "entry": {
        "createRevocation": "Bestellung stornieren",
        "createRma": "Reklamation einreichen",

        "submit_revocation": {
            "title": "Bestellung stornieren",
            "description": "Für Bestellungen die Sie gerade getätigt haben und die **unser Lager noch nicht verlassen haben.**"
        },
        "submit_return": {
            "title": "Retoure beantragen",
            "description": "Für Bestellungen, die bereits **unser Lager verlassen haben.**"
        },
        "submit_rma": {
            "title": "Garantieantrag / Reklamation einreichen",
            "description": "Artikel **innerhalb der Garantiezeit** defekt oder beschädigt?"
        }
    },
    "notice": {
        "infoText": "Sollten Sie Ihre Bestellung erst vor kurzem aufgegeben haben, kann es **bis zu 15 Minuten** dauern, bis Ihre Bestellung in unserem System angekommen ist. Vorher ist ein Widerruf aus technischen Gründen leider nicht möglich. Bitte versuchen Sie es in diesem Fall in einigen Minuten erneut oder kontaktieren Sie unseren Support für weitere Hilfe.",
        "infoText2": "**VORKASSE Bestellung**: Bestellungen die per Vorkasse bezahlt wurden, benötigen keine Stornierung, da diese automatisch storniert werden, wenn die Zahlung nicht innerhalb von 7 Tagen eingeht. Sie können die Bestellung einfach nicht bezahlen und sie wird automatisch storniert.",
    },
    "productList": {
        "title": "Artikel auswählen",
        "description": "Bitte wählen Sie die Artikel aus Ihrer Bestellung aus, die Sie reklamieren möchten. Sie können auch die Menge angeben, falls Sie nur einen Teil der bestellten Artikel zurücksenden möchten.",
    },
    "rma": {
        "order_id_not_found": "Auftragsnummer konnte nicht gefunden werden, bitte versuchen Sie es erneut.",
        "reason_of_return": "Grund der Reklamation",
        "selected_min_one_product": "Bitte wählen Sie mindestens einen Artikel aus.",
        "fill_reason_of_return": "Bitte geben Sie einen Grund für die Reklamation an.",
        "add_pictures": "Fügen Sie Bilder hinzu",
        "add_more_pictures": "Weitere Bilder hinzufügen",
        "add_files_to_return": "Bitte fügen Sie Bilder oder Dokumente hinzu, um Ihre Reklamation zu unterstützen.",
        "accept_privacy_policy": "Bitte akzeptieren Sie die Datenschutzbestimmungen, um fortzufahren.",
        "global_comment": "Allgemeine Bemerkung",
        "privacy_policy": "Ich habe die Datenschutzbestimmungen gelesen und akzeptiere diese*",
        "privacy_policy_description": "Wir werden Ihre Daten sorgfältig und gemäß den gesetzlichen Bestimmungen zum Datenschutz verarbeiten und nutzen. Die von Ihnen angegebenen personenbezogenen Daten werden nur zum Zwecke der Abwicklung Ihrer Kontaktanfrage und zur zweckbezogenen Betreuung verarbeitet. Weitere Details zur Verarbeitung Ihrer personenbezogenen Daten durch baum-bmwshop24.de (eine Marke der Baum Automobile Gmbh & Co. KG) ebenso wie detaillierte Hinweise zu Ihren Betroffenenrechten finden Sie in unseren [Datenschutzbestimmungen](https://www.baum-bmwshop24.de/datenschutz).",
        "success_message": {
            "title": "Anfrage erfolgreich eingereicht",
            "description": "Vielen Dank für Ihre Anfrage. Wir werden diese so schnell wie möglich bearbeiten. **Sie erhalten innerhalb der nächsten 30 Minuten eine Bestätigung des Eingangs per E-Mail.** Wir bearbeiten Ihren Antrag nach Eingang. In der Regel melden wir uns innerhalb von 2 Werktagen bei Ihnen zurück. Bitte warten Sie auf weitere Anweisung durch uns.",
        },
        "close_message": "Sie können das Fenster jetzt schließen oder zurück zur Startseite gehen.",
        "error_message": {
            "title": "Ein Fehler ist aufgetreten",
            "description": "Leider ist bei der Einreichung Ihrer Anfrage ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support für weitere Hilfe.",
        },
        "form_submission_failed": "Die Einreichung Ihrer Reklamation ist fehlgeschlagen. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
        "additionalData": {
            "title": "Handelt es sich um ein Ersatz- oder Zubehörteil?",
            "description": "Damit Ihre Reklamation schnellstmöglich bearbeitet werden kann, benötigen wir diese Information, um die richtigen Daten für die Bearbeitung zu erfassen und an BMW weiterzuleiten. Ersatzteile und Zubehörteile haben andere Garantiebedingungen als Fahrzeuge, daher ist diese Information für die Bearbeitung Ihrer Reklamation entscheidend.",
        },
        "fill_additional_data": "Bitte füllen Sie die ergänzenden Angaben aus, um fortzufahren."
    },
    "orderCancel": {
        "title": "Bestellung stornieren",
        "description": "Bitte kontrollieren Sie die Bestellung und **bestätigen Sie die Stornierung am Ende der Seite.**",
        "form_submission_failed": "Die Stornierung Ihrer Bestellung ist fehlgeschlagen. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support für weitere Hilfe.",
        "success_message": {
            "title": "Bestellung erfolgreich storniert",
            "description": "Ihr Geld wird von unseren Mitarbeitern während unserer regulären Geschäftszeiten automatisch zurückerstattet. Sie erhalten innerhalb der nächsten 30 Minuten eine Bestätigung über den Eingang der Stornierung per E-Mail.",
        }
    },
    "returns": {
        "info": {
            "title": "Retouren der Umwelt zuliebe vermeiden",
            "description": "Jedes retournierte Paket stellt eine Umweltbelastung dar, deshalb setzen wir alles daran, um ein unnötiges Versenden von Artikeln zu minimieren. Mit jeder vermiedenen Retoure wird mindestens 1,7 kg CO 2 eingespart, bei sieben eingesparten Retouren pro Jahr entspricht das also der Kompensationsmenge eines Baumes. Nehmen Sie also gerne im Vorfeld Kontakt mit unserem Support auf, wir helfen Ihnen gerne dabei schon vor Ihrer ersten Bestellung den passenden Artikel zu finden",
            "instructions": "Leitfaden zur Rückgabe: So funktioniert's",
            "more_info": "Weitere Informationen entnehmen Sie gerne unseren [AGB](https://www.baum-bmwshop24.de/agb/) und den [Widerrufsbelehrungen](https://www.baum-bmwshop24.de/widerruf/).",
            "shipping_info": "(*)Für Rücksendungen Standardpakete berechnen wir 7,90 EUR, für Rücksendungen Sperrgutpakete berechnen wir 29,90 EUR. Die Rücksendekosten werden von der Gutschrift abgezogen.",
            "steps": {
                "step_1": "Klicken Sie auf den Button „Retoure jetzt anmelden“ und loggen sich auf der Seite mit Ihrer Kundennummer und Auftragsnummer ein. Diese Daten finden Sie auf dem Lieferschein, der sich im Paket befinden sollte und auf der Rechnung, die Sie per E-Mail erhalten haben.",
                "step_2": "Im nächsten Schritt werden Ihnen alle Artikel aus der Bestellung aufgelistet. Bitte wählen Sie die Artikel, mit Angabe der Menge und dem Rücksendegrund aus. Mit „Weiter“ kommen Sie zum dritten Schritt.",
                "step_3": "Hier haben Sie die Möglichkeit, die zu retournierende Produkte zu überprüfen und final durch Klick auf „Retoure erstellen“ zu bestätigen.",
                "step_4": "Nachdem die Retoure angelegt wurde, drucken Sie sich bitte den Retourenbeleg aus und legen diesen der Rücksendung bei.",
                "step_5": "Für Paketrücksendungen (innerhalb Deutschlands) bieten wir Ihnen ein DHL-Paketschein an. Diesen können Sie sich ebenfalls ausdrucken. Beachten Sie bitte, dass wir Ihnen **keinen** kostenfreien Rückversand(*) anbieten!",
                "step_6": "Bitte verpacken Sie die Artikel für den Rückversand sorgfältig und legen Sie den ausgedruckte Retourenbeleg bei. Den DHL-Paketschein entlang der Markierung abschneiden und auf das Rücksendepaket kleben und zur nächsten DHL-Abgabestelle bringen.",
                "step_7": "Nachdem wir das Paket erhalten haben, erstellen wir eine Stornorechnung und Sie bekommen die Rückerstattung (abzgl. Rücksendekosten) auf dieselbe Zahlungsart zurückerstattet, mit der Sie die Bestellung durchgeführt haben. [br][br]**HINWEIS:** Eine Rückerstattung des Kaufpreises ist nur bei Artikeln ohne Einbauspuren und/oder Beschädigungen in der Originalverpackung möglich",
            }
        }
    }
}